import React, { useEffect, useState } from "react";
import * as S from "./CoverPage.style";
import Cookies from "js-cookie";

const zaiaImage = `${process.env.REACT_APP_STORAGE_ZAIA_RESOURCES}/zaiaFigures/singularity-navigator-white.png`;
const zaiaImageMonaco = `${process.env.REACT_APP_STORAGE_ZAIA_RESOURCES}/zaiaFigures/monaco-logo.svg`;

function CoverPage() {
  const [monacoRedirection, setMonacoRedirection] = useState(false);

  useEffect(() => {
    const location = window.location.href;
    
    if (location.toLowerCase().includes("monaco")) {
      setMonacoRedirection(true);
    }
  }, []);

  const webView = Cookies.get('webView');

  return (
    <S.CoverPage webView={webView}>
      <img className="zaia-image" src={
        monacoRedirection
        ? zaiaImageMonaco
        : zaiaImage
      } alt="SINGULARITY NAVIGATOR" />
    </S.CoverPage>
  );
}

export default CoverPage;
